<template>
  <m-card class="m-auto w-11/12 max-w-sm overflow-visible px-7 py-10 lg:max-w-lg">
    <h1 class="text-center text-2xl font-bold">
      {{ title }}
    </h1>
    <slot />
  </m-card>
</template>

<script setup lang="ts">
  import MCard from '@shared/components/MCard/MCard.vue';
  export interface Props {
    title: string;
  }

  defineProps<Props>();
</script>
